import script from "./SpreadsheetApp.vue?vue&type=script&setup=true&lang=js"
export * from "./SpreadsheetApp.vue?vue&type=script&setup=true&lang=js"

import "./SpreadsheetApp.vue?vue&type=style&index=0&id=8cadb3da&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-8cadb3da"]])

export default __exports__